/** HTTP header sent by the client with the active branch ID */
export const BRANCH_HEADER = "x-branch-id";

/** Default branch created by the multi-branch migration for existing single-location data */
export const DEFAULT_BRANCH_ID = 1;

export const BRANCH_ROLES = ["admin", "manager", "cashier"] as const;
export type BranchRole = (typeof BRANCH_ROLES)[number];

export type BranchSummary = {
  id: number;
  name: string;
  address: string | null;
  phone: string | null;
  taxRate: string | null;
  isActive: boolean;
};
